import React from 'react';

import s from './Version.css';


const Version = () => {
  const versionNumber = "2022.1";
  const theYear = new Date().getFullYear();

  return (
    <div
      id="version"
      className={s.component}
    >
      <span id="version_1" className={s.versionRow}>Updox v{versionNumber}</span>
      <span id="version_2" className={s.versionRow}>&copy; {theYear} Updox</span>
    </div>
  );
};

export default Version;



// WEBPACK FOOTER //
// ./src/components/Version/Version.js